export const officeInfos = [
  {
    title: '+1-825-436-2133',
    link: 'Tel:+1%20(825)%20436%202133',
    imageLink: 'assets/images/phone.png',
    description: 'Call and talk with us.',
  },
  {
    title: 'monisferex@gmail.com',
    link: 'mailto:monisferex@gmail.com',
    imageLink: 'assets/images/email.png',
    description: 'Send Email to us.',
  },
  {
    title: '@MonisferSupport',
    link: 'https://t.me/MonisferSupport',
    imageLink: 'assets/images/telegram.png',
    description: 'Chat with us in Telegram.',
  },
];

export const officePhoneNumber = '+1-825-436-2133';

export const testimonials = [
  {
    title: 'A Google Review',
    comment:
      'Just had my fastest money transfer experience with them. It only took a few hours! They offered a great rate and were so fast in replying to my messages. I would definitely recommend Monisfer. Thanks guys and keep up the great work!',
    name: 'Saeed Reza Toghi Eshghi',
    avatarLink: 'assets/images/avatar_eshgi.jpg',
    link: 'https://g.co/kgs/TZFFHz',
  },
  {
    title: 'A Google Review',
    comment: `They are giving 100% honest and reliable services. I have transferred money for many times using their services and they have always been so quick with the best rate. I never think of any other option for transferring money.`,
    name: 'Ali Lotfi',
    avatarLink: 'assets/images/avatar_lotfi.png',
    link: 'https://g.co/kgs/twdTAQ',
  },
  {
    title: 'A Google Review',
    comment:
      'Monisfer has been my go-to exchange for several months, and I would highly recommend it. Customer service is excellent, and transactions are handled in a timely manner.',
    name: 'Mahmoud Shabani',
    avatarLink: 'assets/images/avatar_shabani.png',
    link: 'https://g.co/kgs/UttGKY',
  },
];

export const reasons = [
  {
    imageLink: 'assets/images/affordability.png',
    title: 'Affordable',
    description: 'Rates',
  },
  {
    imageLink: 'assets/images/quick.png',
    title: 'Quick',
    description: 'Response',
  },
  {
    imageLink: 'assets/images/transparent.png',
    title: 'Transparent',
    description: 'Transactions',
  },
  {
    imageLink: 'assets/images/regulated.png',
    title: 'Regulated',
    description: 'By FINTRAC',
  },
];

export const howWorks = [
  {
    title: 'STEP 1: Call Us',
    description: `Double-check our rates and availability of funds by calling us: <span class="whitespace-nowrap">+1-825-436-2133</span>.`,
  },
  {
    title: 'STEP 2: Exchange Your Money',
    description: `Come by and exchange your money.`,
  },
];
